export const getIsDisabledForAcceptanceTest = () => {
  try {
    const isDisabled = window.localStorage.getItem('messages:disable-onboarding-for-acceptance-test');
    return isDisabled === 'true';
  } catch (e) {
    return false;
  }
};